import { render } from "./center.vue?vue&type=template&id=172a3b81&scoped=true&ts=true"
import script from "./center.vue?vue&type=script&lang=ts&config=true"
export * from "./center.vue?vue&type=script&lang=ts&config=true"

import "./center.vue?vue&type=style&index=0&id=172a3b81&scoped=true&lang=css"
import "./center.vue?vue&type=style&index=1&id=172a3b81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172a3b81"]])

export default __exports__